export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export const validatePhone = (phone: string): boolean => {
  const cleanPhone = phone.replace(/[^\d]/g, '')
  return cleanPhone.length >= 10 && cleanPhone.length <= 11
}

export const validatePhoneForCountry = (phone: string, countryCode?: string | null): boolean => {
  if ((countryCode ?? '+55') === '+55') return validatePhone(phone)
  return phone.replace(/[^\d]/g, '').length >= 4
}

export const validateZipCode = (zipCode: string): boolean => {
  const cleanZipCode = zipCode.replace(/[^\d]/g, '')
  return cleanZipCode.length === 8
}

export const validateRequired = (value: string | undefined | null): boolean => {
  return value !== undefined && value !== null && value.trim() !== ''
}

export const validateAddress = (address: {
  street: string
  number: string
  neighborhood: string
  city: string
  state: string
  zipCode: string
}): { isValid: boolean; errors: string[] } => {
  const errors: string[] = []

  if (!validateRequired(address.street)) {
    errors.push('Rua é obrigatória')
  }

  if (!validateRequired(address.number)) {
    errors.push('Número é obrigatório')
  }

  if (!validateRequired(address.neighborhood)) {
    errors.push('Bairro é obrigatório')
  }

  if (!validateRequired(address.city)) {
    errors.push('Cidade é obrigatória')
  }

  if (!validateRequired(address.state)) {
    errors.push('Estado é obrigatório')
  }

  if (address.zipCode && !validateZipCode(address.zipCode)) {
    errors.push('CEP deve ter 8 dígitos')
  }

  return {
    isValid: errors.length === 0,
    errors
  }
}
